export const required = value => !value || (value && !String(value).trim());
export const number = value => (value && isNaN(Number(String(value).replace(/-/g, "").replace(/ /g, "").replace(/\+/g, "")))) || (value && String(value).length < 6);
export const email = value => (value && !/^\S+@\S+$/i.test(value));
